export default __webpack_public_path__ + "static/media/passport-video.dfb1cccd.png";